import '@fsa/sbx-core-react-mfe/reactDomFindDomNodePolyfill';
import('./src/bootstrap').catch(err => console.error('Failed to load bootstrap:', err));
import('@fsa/app-info').catch(err => console.error('Failed to load @fsa/app-info:', err));
